<template>
    <div class="sustainable-component common-rule">
        <div class="container-fluid p-0">
            <div class="row mb-5">
                <div class="col">
                    Här kan ni skriva det lokala regelverket
                </div>
            </div>
            <div class="row mt-2 mb-5">
                <div class="col-12 col-md-9">
                    <CommonMCEEditor title="Regelverk" v-bind:disabled="enableRegulation == false" v-model:editorcontent="regulation"></CommonMCEEditor>
                </div>
                <div class="col-12 col-md-3 pt-3 pt-md-0">
                    <v-btn v-bind:disabled="disabled" v-if="enableRegulation == false" size="default" width="195" v-bind:class="{'bg-primary' : enableRegulation != true}" @click="enableRegulation = true">
                        {{$t('workorganisation_tab1_tool_change_regulation')}}
                    </v-btn>
                    <br v-if="enableRegulation == false" />
                    <v-btn v-if="enableRegulation == true" size="default" width="195" @click="enableRegulation = false">
                        {{$t('general.workorganisation_general_cancel')}}
                    </v-btn>
                    <br v-if="enableRegulation == true" />
                    <v-btn size="default" width="195" v-bind:class="{'bg-primary' : enableRegulation == true}" class="mt-md-2 ml-2 ml-md-0" v-bind:disabled="enableRegulation == false" @click="saveRegulation">
                        {{$t('general.workorganisation_general_save')}}
                    </v-btn>
                    <br />
                    <v-btn size="default" width="195" class="mt-2" @click="printRegulation">
                        {{$t('general.workorganisation_general_print')}}
                    </v-btn>
                    <br />
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WorkOrganisationService from "../Services/WorkOrganisationService";
    import CommonMCEEditor from './common-mce-editor.vue'
    import CommonSpinner from './common-spinner.vue'

    export default {

        name: 'common-rule',
        props: {
            regulationtype: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components:{
            CommonMCEEditor,
            CommonSpinner
        },
        methods: {
            async saveRegulation() {
                this.loading++;
                try {
                    await WorkOrganisationService.setRegulation(this.regulation, this.regulationtype);
                    this.displaySnackBar("Regelverket har uppdaterats");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async loadRegulation() {
                this.loading++;
                try {
                    var response = await WorkOrganisationService.getRegulation(this.regulationtype);
                    this.regulation = response.Content;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printRegulation() {
                this.newWindow = window.open('/workorganisation/printRegulation?type=' + this.regulationtype, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                enableRegulation:false,
                selected: {},
                regulation: "",
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
        },
        mounted() {
            this.loadRegulation();
        },
        setup () {
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
